export const locales = {
    tr: {
      pages: "Sayfalar",
      nk: "Nasıl Kullanılır?",
      sae: "1. Genel Ayarlar",
      sefeat: "Bu bölümde sisteminizin genel yapılandırmasını yapabilirsiniz.",
      icc: "2. Cihaz Ekleme",
      bepy: "Yeni cihaz eklemek için gerekli bilgileri girin ve Kaydet’e basın.",
      p3Header: "3. Girişler",
      p3Content: `Giriş ekranında soket pinleri konfigüre edilir. Etkin olacaksa “evet” seçilmelidir. <br/>
  Ardından vavien çıkışı ve yerleşim bilgileri (sayfa, kolon, sıra) belirlenir. <br/>
  Klonla butonuyla farklı sayfalara taşıyabilir, ikon seçebilir ve “Giriş Ekle” ile yeni girişler tanımlayabilirsiniz. İstenirse giriş silinebilir.`,
      p4Header: "4. Voltajlar",
      p4Content: `Volt
  ajlar ekranı, akü ya da güç kaynaklarının takibini sağlar. <br/>
  <strong>Soket Pin:</strong> Voltaj kaynağının bağlı olduğu fiziksel pin ya da soket numarasıdır. <br/>
  <strong>Enable:</strong> Voltaj kaynağı izlenecekse "true" olarak seçilir. <br/>
  Sayfa, kolon ve sıra bilgileri girilerek yerleşim tamamlanır. Klonla butonuyla başka sayfalara taşınabilir.`,
      p5Header: "5. Şamandıralar",
      p5Content: `Şamandıra ekranı, araç içi sıvı tankları için kullanılır. <br/>
  <strong>Etkinleştirme:</strong> "Evet" seçilirse sensör aktif olur. <br/>
  <strong>Amaç:</strong> İzlenen sıvı türüdür. <br/>
  <strong>Uyarı Yüzdesi:</strong> Bu seviyeye düşerse kullanıcı uyarılır. <br/>
  <strong>Hata Yüzdesi:</strong> Bu seviyeye düşerse sistem hata üretir. <br/>
  <strong>Kilit Pini:</strong> Düşük seviye gibi durumlarda çıkış kilitlenebilir. <br/>
  Yerleşim bilgileri girildikten sonra klonlama ve ikon seçimi yapılabilir. “Şamandıra Ekle” ve “Sil” seçenekleri ile işlem yapılabilir.`,
      p6Header: "6. Röle",
      p6Content: `Röleler, elektriksel devreleri kontrol etmek için kullanılır. <br/>
  <strong>Aktif:</strong> Röle kullanılacaksa “evet” seçilir. <br/>
  <strong>Kısa Devre Soket Pini:</strong> Bu pin üzerinden alınan değerler ile kısa devre algılanır. <br/>
  <strong>Açık Devre Soket Pini:</strong> Röle kapalıyken beklenen voltaj gelmezse açık devre var demektir. <br/>
  <strong>Kısa Devre Voltajı:</strong> Bu değerin üzerindeki voltaj kısa devre olarak yorumlanır. <br/>
  <strong>Açık Devre Voltajı:</strong> Bu değerin altındaki voltaj açık devre kabul edilir. <br/>
  <strong>Manuel Geçersiz Kılma Süresi:</strong> Röle manuel olarak kontrol edildikten sonra otomatik moda dönüş süresidir.`,
      p7Header: "7. Ayarlar",
      p7Content: `Bu bölüm, sistem voltajı belirli seviyelere düştüğünde yapılacak işlemleri tanımlar. <br/>
  <strong>Zorunlu Kapanma Voltajı:</strong> Sistem voltajı bu seviyenin altına düşerse kapanma başlatılır. <br/>
  <strong>İsteğe Bağlı Kapanma Voltajı:</strong> Sistem bazı özellikleri kapatarak enerji tasarrufu sağlar. <br/>
  <strong>Başlangıç Uyarı Voltajı:</strong> Bu seviyenin altına düşüldüğünde uyarı başlatılır. <br/>
  <strong>Kurtarma Voltajı:</strong> Sistem normal moda bu seviyeye çıkınca döner. <br/>
  <strong>Zorunlu Kapanma Süresi:</strong> Dalgalanmalara karşı belirli süre düşük voltaj izlenir.`,
      p8Header: "8. Sistemin Amacı Nedir?",
      p8Content: `JSON dosyası, Octoopi Van’ın donanımsal konfigürasyonunu içerir. <br/>
  Hangi pinlerde hangi cihazların bağlı olduğunu, sayfa ve ekran konumlarını, ikonları ve limit değerlerini belirlemenizi sağlar. <br/>
  Bu yapı sayesinde ekranınızı kişiselleştirebilirsiniz.`,
      p9Header: "9. Bilgilendirme",
      p9Content: `Bu adımlarda bir sorun yaşarsanız, sayfanın alt kısmında bulunan iletişim alanı üzerinden bizimle iletişime geçebilirsiniz.`,
      ytb: "Yardım Talebi Gönder",
      titlee: "Başlık",
      mail: "E-Posta",
      description: "Açıklama",
      tb: "Gönder"
    },
  
    en: {
      pages: "Pages",
      nk: "How To Use?",
      sae: "1. General Settings",
      sefeat: "In this section you can configure the overall system settings.",
      icc: "2. Add Device",
      bepy: "Enter the required information to add a new device and click Save.",
      p3Header: "3. Entries",
      p3Content: `On the entry screen, socket pins are configured. If you want it active, select “yes”. <br/>
  Then the vavien output and placement details (page, column, row) are set. <br/>
  Using the Clone button you can move it to different pages, choose an icon, and with “Add Entry” define new entries. Entries can be deleted if desired.`,
      p4Header: "4. Voltages",
      p4Content: `The voltages screen tracks batteries or power supplies. <br/>
  <strong>Socket Pin:</strong> The physical pin or socket number where the power source is connected. <br/>
  <strong>Enable:</strong> Select "true" if you want to monitor the power source. <br/>
  Placement is completed by entering page, column, and row details. You can clone to move to other pages.`,
      p5Header: "5. Float Sensors",
      p5Content: `The float sensor screen is used for in-vehicle fluid tanks. <br/>
  <strong>Activation:</strong> Select "Yes" to activate the sensor. <br/>
  <strong>Purpose:</strong> The type of fluid being monitored. <br/>
  <strong>Warning Level (%):</strong> User is alerted when it drops to this level. <br/>
  <strong>Error Level (%):</strong> System generates an error when it drops to this level. <br/>
  <strong>Lock Pin:</strong> The output can be locked in low-level situations. <br/>
  After entering placement details, you can clone and select an icon. Use “Add Float” and “Delete” options to manage sensors.`,
      p6Header: "6. Relay",
      p6Content: `Relays are used to control electrical circuits. <br/>
  <strong>Active:</strong> Select “yes” if relay will be used. <br/>
  <strong>Short Circuit Pin:</strong> Values from this pin detect short circuits. <br/>
  <strong>Open Circuit Pin:</strong> If expected voltage is missing when relay is off, it's an open circuit. <br/>
  <strong>Short Circuit Voltage:</strong> Voltages above this value are considered short circuits. <br/>
  <strong>Open Circuit Voltage:</strong> Voltages below this value are considered open circuits. <br/>
  <strong>Manual Override Duration:</strong> Time before returning to auto mode after manual control.`,
      p7Header: "7. Settings",
      p7Content: `This section defines actions when system voltage falls to certain levels. <br/>
  <strong>Forced Shutdown Voltage:</strong> Shutdown initiates if system voltage falls below this level. <br/>
  <strong>Optional Shutdown Voltage:</strong> Some features turn off to save energy. <br/>
  <strong>Startup Warning Voltage:</strong> Warning starts when it drops below this level. <br/>
  <strong>Recovery Voltage:</strong> System returns to normal mode when it reaches this level. <br/>
  <strong>Forced Shutdown Duration:</strong> Low voltage is monitored for a set duration against fluctuations.`,
      p8Header: "8. What Is The Purpose Of The System?",
      p8Content: `The JSON file contains the hardware configuration of the Octoopi Van. <br/>
  It lets you specify which devices are connected to which pins, page and screen positions, icons, and limit values. <br/>
  This structure allows you to customize your display.`,
      p9Header: "9. Information",
      p9Content: `If you encounter any issues during these steps, please contact us via the form at the bottom of the page.`,
      ytb: "Send Support Request",
      titlee: "Title",
      mail: "E-Mail",
      description: "Description",
      tb: "Submit"
    },
  
    de: {
      pages: "Seiten",
      nk: "Anleitung",
      sae: "1. Allgemeine Einstellungen",
      sefeat: "In diesem Abschnitt können Sie die allgemeinen Systemeinstellungen vornehmen.",
      icc: "2. Gerät Hinzufügen",
      bepy: "Geben Sie die erforderlichen Informationen ein, um ein neues Gerät hinzuzufügen, und klicken Sie auf Speichern.",
      p3Header: "3. Eingänge",
      p3Content: `Auf dem Eingabebildschirm werden die Steckdosenpins konfiguriert. Soll es aktiviert sein, wählen Sie „ja“. <br/>
  Dann werden der Vavien-Ausgang und Platzierungsangaben (Seite, Spalte, Reihe) festgelegt <br/>
  Mit der Schaltfläche „Klonen“ können Sie auf verschiedene Seiten verschieben, ein Symbol auswählen und mit „Eintrag Hinzufügen" neue Einträge definieren. Einträge können bei Bedarf gelöscht werden.`,
      p4Header: "4. Spannungen",
      p4Content: `Der Spannungsbildschirm verfolgt Batterien oder Stromquellen. <br/>
  <strong>Steckplatz-Pin:</strong> Physischer Pin oder Steckplatznummer der Stromquelle. <br/>
  <strong>Aktivieren:</strong> Wählen Sie "true" zur Überwachung der Stromquelle. <br/>
  Durch Eingabe von Seite, Spalte und Reihe erfolgt die Platzierung. Mit Klonen auf andere Seiten verschieben.`,
      p5Header: "5. Schwimmersensoren",
      p5Content: `Der Schwimmersensor-Bildschirm wird für Fahrzeugflüssigkeitstanks verwendet. <br/>
  <strong>Aktivierung:</strong> Wählen Sie "Ja" zum Aktivieren des Sensors. <br/>
  <strong>Zweck:</strong> Art der überwachten Flüssigkeit. <br/>
  <strong>Warnstufe (%):</strong> Benutzer wird gewarnt, wenn sie erreicht wird. <br/>
  <strong>Fehlerstufe (%):</strong> System erzeugt einen Fehler, wenn sie erreicht wird. <br/>
  <strong>Sperr-Pin:</strong> Ausgang kann bei niedrigem Pegel gesperrt werden. <br/>
  Nach Eingabe der Platzierungsdaten klonen und Symbol auswählen. Optionen “Schwimmer Hinzufügen” und “Löschen”.`,
      p6Header: "6. Relais",
      p6Content: `Relais werden zum Steuern elektrischer Schaltkreise verwendet. <br/>
  <strong>Aktiv:</strong> Wählen Sie „ja“, wenn Relais verwendet wird. <br/>
  <strong>Kurzschluss-Pin:</strong> Werte dieses Pins erkennen Kurzschlüsse. <br/>
  <strong>Offener Stromkreis-Pin:</strong> Wenn Spannung fehlt, ist es ein offener Stromkreis. <br/>
  <strong>Kurzschlussspannung:</strong> Spannungen über diesem Wert gelten als Kurzschluss. <br/>
  <strong>Offene Stromkreis-Spannung:</strong> Spannungen unter diesem Wert gelten als offener Stromkreis. <br/>
  <strong>Dauer des manuellen Überschreibens:</strong> Zeit bis Rückkehr in den Automatikmodus nach manueller Steuerung.`,
      p7Header: "7. Einstellungen",
      p7Content: `In diesem Bereich werden Aktionen definiert, wenn die Systemspannung bestimmte Werte erreicht. <br/>
  <strong>Erzwungene Abschaltspannung:</strong> Abschaltung startet bei Unterschreiten dieses Wertes. <br/>
  <strong>Optionale Abschaltspannung:</strong> Einige Funktionen abschalten, um Energie zu sparen. <br/>
  <strong>Startwarnspannung:</strong> Warnung startet bei Unterschreiten dieses Wertes. <br/>
  <strong>Wiederherstellungsspannung:</strong> System kehrt beim Erreichen dieses Wertes in den Normalmodus zurück. <br/>
  <strong>Dauer der erzwungenen Abschaltung:</strong> Niedrige Spannung wird für eine festgelegte Dauer überwacht.`,
      p8Header: "8. Wozu dient das System?",
      p8Content: `Die JSON-Datei enthält die Hardwarekonfiguration des Octoopi Van. <br/>
  Sie definiert, welche Geräte an welchen Pins angeschlossen sind, Seiten- und Bildschirmpositionen, Symbole und Grenzwerte. <br/>
  Mit dieser Struktur können Sie Ihre Anzeige anpassen.`,
      p9Header: "9. Informationen",
      p9Content: `Wenn Sie während dieser Schritte auf Probleme stoßen, kontaktieren Sie uns bitte über das Formular am Ende der Seite.`,
      ytb: "Support-Anfrage Senden",
      titlee: "Titel",
      mail: "E-Mail",
      description: "Beschreibung",
      tb: "Absenden"
    }
  };